import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    console.log('AuthCallback: Token received:', token ? 'present' : 'missing');
    console.log('AuthCallback: All search params:', Object.fromEntries(searchParams.entries()));
    
    if (token) {
      // Store the token
      localStorage.setItem('token', token);
      console.log('AuthCallback: Token stored in localStorage');
      
      // Small delay to ensure localStorage is updated
      setTimeout(() => {
        navigate('/');
      }, 100);
    } else {
      // No token received, redirect to login
      console.log('AuthCallback: No token, redirecting to login');
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }}>
      {user ? 'Welcome back!' : 'Completing sign in...'}
    </div>
  );
};

export default AuthCallback;
